import React, { useState } from 'react';
import { styled } from '../../../../../shared/Theme/theme';
import { contact } from '../../../../../../models/entities/businessPartner/contact';
import Loader from '../../../../../shared/SmallComponents/Loader';
import { ColumnType } from '../../../../../shared/Grid/types/Column';
import Grid from '../../../../../shared/Grid/Grid';
import CustomModal, { ModalTriggerProps } from '../../../../../shared/Modal/Modal';
import ContactFormConnected, { formMode } from '../../ContactForm/ContactFormConnected';
import Button from '../../../../../shared/SmallComponents/Button';
import attachment from '../../../../../../static/icons/attachment.svg';
import { settings } from '../../../../../../models/entities/businessPartner/businessPartner';

type Props = {
    contacts?: Array<contact>;
    localization: any;
    settings?: settings;
};

const BusinessPartnersContacts = ({ contacts, localization, settings }: Props) => {
    const { name, email, phoneNumber, role, comment, backupContactName, receiveFinancialDocuments } =
        localization.contacts.grid.columns;
    const gridColumns: Array<ColumnType<contact>> = [
        {
            title: name,
            field: 'name',
            sortable: false,
            isDisplayed: true
        },
        {
            title: email,
            field: 'email',
            sortable: false,
            isDisplayed: true
        },
        {
            title: phoneNumber,
            field: 'phoneNumber',
            sortable: false,
            isDisplayed: true
        },
        {
            title: role,
            field: 'role',
            sortable: false,
            isDisplayed: true
        },
        {
            title: receiveFinancialDocuments,
            field: 'receiveFinancialDocuments',
            sortable: false,
            isDisplayed: true,
            columnType: 'bool'
        },
        {
            title: backupContactName,
            field: 'backupContactName',
            sortable: false,
            isDisplayed: true
        },
        {
            title: comment,
            field: 'comment',
            sortable: false,
            isDisplayed: true
        }
    ];

    const [modalVisible, setVisible] = useState(false);
    const [addContactModalVisible, setAddContactModalVisible] = useState(false);
    const [contact, setContact] = useState({} as contact);
    return (
        <ContactsWrapper>
            {contacts ? (
                <>
                    <CustomModal
                        title={{ icon: attachment, text: localization.contacts.modal.add_title }}
                        isOpen={addContactModalVisible}
                        Trigger={(props: ModalTriggerProps) => (
                            <ButtonContainer>
                                <Button onClick={() => setAddContactModalVisible(true)} width="auto" buttonType="hollow" padding="4px 12px">
                                    {localization.contacts.add_contact}
                                </Button>
                            </ButtonContainer>
                        )}
                        Content={(
                            setVisible?: React.Dispatch<React.SetStateAction<boolean>>,
                            setConfirm?: React.Dispatch<React.SetStateAction<boolean>>
                        ) => {
                            return (
                                <ContactFormConnected
                                    mode={formMode.NEW}
                                    openedFromModal={setVisible ? { setVisible: setAddContactModalVisible } : undefined}
                                    confirmation={setConfirm ? { setConfirm } : undefined}
                                />
                            );
                        }}
                        onCancelCallback={() => setAddContactModalVisible(false)}
                        width="500px"
                    />
                    {contacts.length > 0 ? (
                        <GridWrapper>
                            <Grid<contact>
                                columns={gridColumns}
                                data={contacts}
                                localization={localization.contacts.grid}
                                settings={settings}
                                onSettingsClick={() => console.log('settings')}
                                onRowMoreOptionsClick={(row) => {
                                    setContact(row);
                                    setVisible(true);
                                }}
                                menuType="businessPartnerContactMenu"
                            />
                            {modalVisible && (
                                <CustomModal
                                    title={{ icon: attachment, text: localization.contacts.modal.edit_title }}
                                    isOpen={true}
                                    Content={(
                                        setModalVisible?: React.Dispatch<React.SetStateAction<boolean>>,
                                        setConfirm?: React.Dispatch<React.SetStateAction<boolean>>
                                    ) => {
                                        return (
                                            <ContactFormConnected
                                                mode={formMode.EDIT}
                                                contact={contact}
                                                openedFromModal={{ setVisible }}
                                                confirmation={setConfirm ? { setConfirm } : undefined}
                                            />
                                        );
                                    }}
                                    onCancelCallback={() => {
                                        setVisible(false);
                                        setContact({} as contact);
                                    }}
                                    width="393px"
                                />
                            )}
                        </GridWrapper>
                    ) : (
                        <EmaptyStateText>{localization.contacts.empty_state}</EmaptyStateText>
                    )}
                </>
            ) : (
                <Loader />
            )}
        </ContactsWrapper>
    );
};

const GridWrapper = styled.div`
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-y: overlay;
    height: 100%;
    width: 100%;
`;

const ContactsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const EmaptyStateText = styled.span`
    color: ${(props) => props.theme.colors.emptyStateText};
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
`;

export default BusinessPartnersContacts;
